import type { PortableTextBlock } from '@portabletext/types';

export type ServiceCardDescription = PortableTextBlock[] | null;

export function stringToServiceCardDescription(text: string): ServiceCardDescription {
    const t = text.trim();
    if (!t) return null;

    return [
        {
            _type: 'block',
            _key: 'generated',
            style: 'normal',
            markDefs: [],
            children: [{ _type: 'span', _key: 'span', text: t, marks: [] }],
        },
    ];
}

/** Stare pole `text` + nowe Portable Text z Sanity. */
export function normalizeServiceCardDescription(raw: unknown): ServiceCardDescription {
    if (Array.isArray(raw) && raw.length > 0) {
        return raw as PortableTextBlock[];
    }
    if (typeof raw === 'string' && raw.trim()) {
        return stringToServiceCardDescription(raw);
    }
    return null;
}

export function hasServiceCardDescription(desc: ServiceCardDescription): boolean {
    return Array.isArray(desc) && desc.length > 0;
}

export function portableTextToPlain(blocks: ServiceCardDescription): string {
    if (!blocks?.length) return '';

    return blocks
        .filter((b) => b._type === 'block')
        .map((block) => {
            const children = (block as PortableTextBlock & { children?: { text?: string }[] }).children;
            return (children ?? []).map((c) => c.text ?? '').join('');
        })
        .filter(Boolean)
        .join('\n');
}
